import React from 'react';
import {
  TagOverrides,
  createTagOverride,
  TextAppearance,
  Link,
  LinkProps,
  Text,
  Richtext,
  styled,
} from '@vw-marketing/us-components';
import { useTrackingManager } from '../../../services/use-tracking-manager';

const CopySectionWrapper: any = styled.div`
  width: 100%;
`;

export const StyledStrong: any = styled.strong`
  color: inherit;
`;
const CopySection = () => {
  const trackingManager = useTrackingManager();
  const copyText =
    'To schedule your service, visit [**Find a Dealer **](/en/dealer-search.html) to find the dealer nearest you. Please contact [**Volkswagen Customer CARE**](/en/contact.html) for assistance.';

  const onClickLink = (e: any) => {
    const elem = e.target;
    const domain = window.location.hostname;
    const href = elem.getAttribute('href');
    const target = elem.getAttribute('target');
    const value = elem.text;

    trackingManager.trackRecallsGlobalEvent(
      'VWBasic_Link_Click',
      {
        url: `${domain}${href}`,
        name: value,
        newTab: target === '_blank' ? true : false,
      },
      undefined,
    );
  };

  const tagOverrides: TagOverrides = {
    span: createTagOverride(Text, {
      appearance: TextAppearance.copy200,
    }),
    strong: createTagOverride(StyledStrong),
    a: createTagOverride(Link, {
      isInline: true,
      onClick: onClickLink,
    } as LinkProps),
  };
  return (
    <CopySectionWrapper>
      <Richtext markdown={copyText} overrides={tagOverrides} />
    </CopySectionWrapper>
  );
};

export default CopySection;
